import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'ucfirst'
})
export class UcFirstPipe implements PipeTransform {

  constructor(private _sanitizer: DomSanitizer) {
  }

  transform(v: string): string {
      if (!v) {
        return v;
      }

      return v[0].toUpperCase() + v.substr(1).toLowerCase();
  }
}
